import React from 'react';
import type { BaseBoxProps, StyleSystemProps } from '@withjoy/joykit';
import { Box, TextV2 } from '@withjoy/joykit';
import { StyledItemBox, StyledProductPhoto, StyledProductPhotoBox, StyledGridBox, StyledTitleText, styles } from './ItemBase.styles';
import { addRendition } from '@shared/utils/photoRendition';
import type { CookedProduct } from '@apps/registry/common/selectors/ProductListSelector';

export type ItemBaseVariant = 'normal' | 'transparent';

type ItemBaseProps = Readonly<{
  product: Partial<CookedProduct>;
  siteName?: string | null;
  variant?: ItemBaseVariant;
  inStock?: boolean;
  registryItemId?: string;
  productPhotoStyles?: StyleSystemProps;
}> &
  BaseBoxProps;

export const ItemBase: React.FC<ItemBaseProps> = ({ product, siteName, variant, inStock, __css, children, productPhotoStyles }) => {
  const gridBoxStyles = inStock !== false ? {} : { ...styles.outOfStockGridBox };

  return (
    <StyledItemBox
      variant={variant}
      paddingX={5}
    >
      <Box __css={gridBoxStyles}>
        <StyledGridBox
          display={productPhotoStyles?.height ? 'flex' : 'grid'}
          gridTemplateColumns="0.5fr 1fr 0"
          gridGap="12px"
          {...__css}
          inStock={inStock}
        >
          <StyledProductPhotoBox __css={{ ...styles.productPhotoBoxStyles, ...productPhotoStyles }}>
            <StyledProductPhoto backgroundImage={addRendition({ url: product.image, renditionSize: 'medium', isProduct: true })} />
          </StyledProductPhotoBox>
          <Box>
            <Box>
              {siteName && (
                <TextV2
                  typographyVariant="label2"
                  color="mono12"
                  fontFamily="Inter UI"
                >
                  {siteName}
                </TextV2>
              )}
              <StyledTitleText
                typographyVariant="hed1"
                component="p"
                __css={styles.titleText}
                fontFamily="Inter UI"
              >
                {product.title}
              </StyledTitleText>
            </Box>
            {children}
          </Box>
        </StyledGridBox>
      </Box>
    </StyledItemBox>
  );
};
